import { Column } from "../../../../core/components/Column";
import { ModalSimple } from "../../../../core/components/Modal";
import { Row } from "../../../../core/components/Row";
import { TextComponent } from "../../../../core/components/TextComponent";
import { Benefits } from "../../../../core/icons/Benefits";
import { Terms } from "../../../../core/icons/Terms";
import { WarningBG } from "../../../../core/icons/Warning";
import { Why } from "../../../../core/icons/Why";
import { CardPlanSubscription } from "../components/CardPlanSubscription";
import { List } from "../components/List";
import { NoteInformation } from "../components/CardInformation";
import { TitleList } from "../components/TitleList";
import { useSubscription } from "../hook/useSuscription";
import { calculateDate } from "../../../../core/constants/constants";

export const SubscriptionScreen = () => {
	const { subscriptionsAll, subscriptionsByUser, selectedValue, isLoading, isOpenWarning, handleChange, handleAcceptSubscription, handleCancelSubscription, setIsOpenWarning } = useSubscription();
	const titleList1 = {
		icon: <Benefits />,
		text: "Subscription Benefits",
		subtext: "Discover the many benefits of our subscription below.",
	};

		const itemsList1 = [
			{
				text: "Reveal Likes You",
				subtext: "See full profiles in the Likes You section and respond immediately.",
			},
			{
				text: "Five Included Instant Messages Each Paid Month",
				subtext: "Send up to five introductions before matching in each paid subscription month.",
			},
			{
				text: "Message Before Matching",
				subtext: "Use a short Instant Message to introduce yourself before a mutual like.",
			},
			{
				text: "New Nearby Members Alerts",
				subtext: "Get notified when new members join within your saved distance settings.",
			},
		];

	const titleList2 = {
		icon: <Why />,
		text: "Why Go Premium?",
		subtext: "Upgrade to Premium for exclusive features",
	};

		const itemsList2 = [
			{
				text: "Connect Sooner",
				subtext: "Reveal people who already like you instead of waiting to find them in Discovery.",
			},
			{
				text: "A Fresh Allowance Every Paid Month",
				subtext: "The five included Instant Messages refresh every month, including during annual plans. Unused included messages do not roll over.",
			},
	];

	const titleList3 = {
		icon: <Terms />,
		text: "Subscription Terms",
		subtext: "Please review the subscription terms below.",
	};

	const itemsList3 = [
		{
			text: "All subscriptions are auto-renewing and will be charged to your account at confirmation of purchase.",
		},
		{
			text: "You can cancel your subscription at any time.",
		},
	];

	return (
		<>
			<Column
				crossAxisAlignment="start"
				className="bg-white p-4 gap-4 md:gap-5 max-md:overflow-y-auto"
			>
				<TextComponent
					variant="h5"
					className="font-semibold"
				>
					Subscription Plan
				</TextComponent>
				<Row className="w-full gap-5 max-lg:flex-col">
					<Column className="relative bg-socondary px-7 py-5 gap-5 rounded-lg lg:w-1/2">
						<div className="-left-3 top-7 w-6 h-6 rounded-full bg-white absolute" />
						<Column>
							<TextComponent
								variant="h1"
								className="text-primary font-semibold"
							>
								Basic Features
							</TextComponent>
							<TextComponent variant="h6">Free for all users</TextComponent>
						</Column>
						<div className="w-full border-t border-primaryLight" />
						<List
							text="Unlimited Browsing"
							subtext="Swipe, like, and match with as many profiles as you like."
						/>
							<List
								text="Profile Matching"
								subtext="Match with any user who likes you back."
							/>
							<List
								text="Free Matched Chat"
								subtext="Once you both like each other, you can chat together for free."
							/>
					</Column>
					<Column className="relative bg-cyanLight px-7 py-5 gap-5 rounded-lg lg:w-1/2">
						<div className="-left-3 top-7 w-6 h-6 rounded-full bg-white absolute" />
						<CardPlanSubscription
							subscriptionsAll={subscriptionsAll}
							selectedValue={selectedValue}
							subscription_id={subscriptionsByUser?.subscription_id || ""}
							onChange={handleChange}
							subscriptionsByUser={subscriptionsByUser}
							setIsOpenWarning={setIsOpenWarning}
							handleAcceptSubscription={handleAcceptSubscription}
							free_subscription={subscriptionsByUser?.purchase_from || ""}
							status={subscriptionsByUser?.status || ""}
							isLoading={isLoading}
						/>
					</Column>
				</Row>
				<TitleList
					icon={titleList1.icon}
					text={titleList1.text}
					subtext={titleList1.subtext}
				/>
				<div className="w-full border-t border-grayLight" />
				{itemsList1.map((item, index) => (
					<List
						key={index}
						text={item.text}
						subtext={item.subtext}
					/>
				))}
					<NoteInformation
						title="Note:"
						description="Included Instant Messages refresh to five each paid month and do not roll over. Any separately purchased credits remain available."
					className="bg-grayDefault text-graySecondary"
				/>
				<div />
				<TitleList
					icon={titleList2.icon}
					text={titleList2.text}
					subtext={titleList2.subtext}
				/>
				<div className="w-full border-t border-grayLight" />
				{itemsList2.map((item, index) => (
					<List
						key={index}
						text={item.text}
						subtext={item.subtext}
					/>
				))}
				<div />
				<TitleList
					icon={titleList3.icon}
					text={titleList3.text}
					subtext={titleList3.subtext}
				/>
				<div className="w-full border-t border-grayLight" />
				{itemsList3.map((item, index) => (
					<List
						key={index}
						text={item.text}
					/>
				))}
					<NoteInformation
					title={
						<img
							className="w-28"
							src="/hookup4u-Logo-BP.png"
							height={96}
							width={250}
							alt="unjabbed-logo"
						/>
					}
						description=" - Browse, like, match and chat with your matches for free. Subscribe to reveal Likes You and send Instant Messages before matching."
					className="bg-socondary text-black"
				/>
			</Column>
			{isOpenWarning && subscriptionsByUser && (
				<ModalSimple
					title="Cancel Subscription"
					variant="secondary"
					actionExecuted={isOpenWarning}
					onClose={() => {
						setIsOpenWarning(false);
					}}
					onAction={handleCancelSubscription}
					icon={<WarningBG />}
				>
					Are you sure you want to cancel your subscription?
					Your subscription will remain active until <span className="text-primary font-semibold">{calculateDate(new Date(subscriptionsByUser.date_expiration))}</span>
				</ModalSimple>
			)}
		</>
	);
};
